import React, { FunctionComponent } from "react";

import {
  partTypeAccessory,
  partTypePackage,
  partTypeTire,
  partTypeWheel,
} from "../../../constants/partTypes";
import {
  OrderItemAccessory,
  OrderItemPackage,
  OrderItemTire,
  OrderItemWheel,
} from "../../../stores/slices/cartSlice";
import { useOrderDetails } from "../useOrderDetails";
import { CartItemAccessory } from "./items/CartItemAccessory";
import { CartItemPackage } from "./items/CartItemPackage";
import { CartItemTire } from "./items/CartItemTire";
import { CartItemWheel } from "./items/CartItemWheel";

export const CartOrders: FunctionComponent = () => {
  const { data, isOrder } = useOrderDetails();
  return (
    <>
      {data?.orderItemList.map((orderItem) => {
        switch (orderItem.itemType) {
          case partTypeAccessory:
            return (
              <CartItemAccessory
                isOrder={isOrder}
                key={orderItem.itemId}
                orderItem={orderItem as OrderItemAccessory}
              />
            );
          case partTypePackage:
            return (
              <CartItemPackage
                isOrder={isOrder}
                key={orderItem.itemId}
                orderItem={orderItem as OrderItemPackage}
              />
            );
          case partTypeTire:
            return (
              <CartItemTire
                isOrder={isOrder}
                key={orderItem.itemId}
                orderItem={orderItem as OrderItemTire}
              />
            );
          case partTypeWheel:
            return (
              <CartItemWheel
                isOrder={isOrder}
                key={orderItem.itemId}
                orderItem={orderItem as OrderItemWheel}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};
